<ng-container *ngIf="action$ | async as action">
  <div [pTooltip]="(tooltip$ | async) ?? action.tooltip ?? action.description" tooltipPosition="top" style="display: inline-block;">
  <p-button
    [icon]="'pi ' + (action.icon ? 'pi-' + action.icon : 'pi-hidden')"
    [ngClass]="action.name + ' hide-label-responsive'" [label]="action.description"
    ntapDebounceClick (onClick)="executeAction($event)" [disabled]="(isDisabled$ | async) ?? true"></p-button>
    </div>
</ng-container>
<p-confirmDialog #cd header="Potvrda" width="425" appendTo="body" [key]="key">
  <ng-template pTemplate="footer">
    <div class="flex inline-flex">
      <span class="mr-2 mb-2 vertical-align-middle">
        <p-checkbox [(ngModel)]="this.commonConfirmActionService.addPodjedinice" [binary]="true" inputId="binary"></p-checkbox>
        <span class="ml-2">Uključi i niže jedinice gradiva</span>
      </span>
    </div>
    <button type="button" pButton icon="pi pi-times" label="Odustani" (click)="cd.reject()"></button>
    <button type="button" pButton icon="pi pi-check" label="Potvrdi" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
